import type { TFunction } from 'i18next';

import type { ArtStyleCopy } from './art-style-summary';

/**
 * The Art Style card's copy: one literal `t()` key per id, so the extractor harvests every one; the `switch` is
 * exhaustive, so a new id fails the typecheck until it has its copy. The style's name is the owner's own and shows
 * as is; a style saved without a name falls back to the wording the rest of the app uses for it.
 */
export const artStyleCopy = (t: TFunction, c: ArtStyleCopy): string => {
  switch (c.id) {
    case 'drawing-samples':
      return t('Drawing samples');
    case 'no-primary-style':
      return t('No primary style yet');
    case 'style-name':
      return c.name || t('Your primary art style');
    case 'set-up':
      return t('Set up your art style');
    case 'set-up-style':
      return t('Set up your style');
    case 'open-style':
      return c.name ? t('Open {{name}}', { name: c.name }) : t('Open art style');
    case 'choose-a-style':
      return t('Choose a style');
    case 'open-art-style':
      return t('Open art style');
  }
};
